// studentsPlacedData.js
const studentsPlacedData = [
    {
      SNo: 1,
      UniversitySerialNo: "21VV5A0472",
      StudentName: "Kolli Tarakeswari ",
      Discipline: "ECE",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "Moschip",
      Package: "6 LPA",
      Role: ""
    },
    {
      SNo: 2,
      UniversitySerialNo: "20VV1A0455",
      StudentName: "Thummepalli Siva Adarsh",
      Discipline: "ECE",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "Pennant Technologies Pvt.Ltd.",
      Package: "4 LPA",
      Role: "Associate Software Engineer Trainee"
    },
    {
      SNo: 3,
      UniversitySerialNo: "20VV1A0503",
      StudentName: "Ala Venkat Choudhary",
      Discipline: "CSE",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "Pennant Technologies Pvt.Ltd.",
      Package: "4 LPA",
      Role: "Associate Software Engineer Trainee"
    },
    {
      SNo: 4,
      UniversitySerialNo: "20VV1A0549",
      StudentName: "Shaik Thousif",
      Discipline: "CSE",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "Pennant Technologies Pvt.Ltd.",
      Package: "4 LPA",
      Role: "Associate Software Engineer Trainee"
    },
    {
      SNo: 5,
      UniversitySerialNo: "20VV1A0505",
      StudentName: "Arli Sasi Vardhan",
      Discipline: "CSE",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "Pennant Technologies Pvt.Ltd.",
      Package: "4 LPA",
      Role: "Associate Software Engineer Trainee"
    },
    {
      SNo: 6,
      UniversitySerialNo: "20VV1A0533",
      StudentName: "Nurukurthi Yaswanth",
      Discipline: "CSE",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "Pennant Technologies Pvt.Ltd.",
      Package: "4 LPA",
      Role: "Associate Software Engineer Trainee"
    },
    {
      SNo: 7,
      UniversitySerialNo: "20VV1A0537",
      StudentName: "PerlaVenkata Laxmi Subha Satya Anusha",
      Discipline: "CSE",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "Pennant Technologies Pvt.Ltd.",
      Package: "4 LPA",
      Role: "Associate Software Engineer Trainee"
    },
    {
      SNo: 8,
      UniversitySerialNo: "21VV5A0572",
      StudentName: "Koti Tarun Kumar",
      Discipline: "CSE",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "Pennant Technologies Pvt.Ltd.",
      Package: "4 LPA",
      Role: "Associate Software Engineer Trainee"
    },
    {
      SNo: 9,
      UniversitySerialNo: "20VV1A0509",
      StudentName: "Challa Durga Harika",
      Discipline: "CSE",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "Pennant Technologies Pvt.Ltd.",
      Package: "4 LPA",
      Role: "Associate Software Engineer Trainee"
    },
    {
      SNo: 10,
      UniversitySerialNo: "20VV1A0502",
      StudentName: "Orisi Gayatri",
      Discipline: "CSE",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "Pennant Technologies Pvt.Ltd.",
      Package: "4 LPA",
      Role: "Associate Software Engineer Trainee"
    },
    {
      SNo: 11,
      UniversitySerialNo: "20VV1A0559",
      StudentName: "Veeramallu Jaya Sri",
      Discipline: "CSE",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "Pennant Technologies Pvt.Ltd.",
      Package: "4 LPA",
      Role: "Associate Software Engineer Trainee"
    },
    {
      SNo: 12,
      UniversitySerialNo: "21VV5A0569",
      StudentName: "Kandregula Dinesh",
      Discipline: "CSE",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "Pennant Technologies Pvt.Ltd.",
      Package: "4 LPA",
      Role: "Associate Software Engineer Trainee"
    },
    
    {
      SNo: 13,
      UniversitySerialNo: "20VV1A1230",
      StudentName: "Koduri Jayanth",
      Discipline: "IT",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "Pennant Technologies Pvt.Ltd.",
      Package: "4 LPA",
      Role: "Associate Software Engineer Trainee"
    },
    {
      SNo: 14,
      UniversitySerialNo: "20VV1A1241",
      StudentName: "Nalla Adarsh",
      Discipline: "IT",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "Pennant Technologies Pvt.Ltd.",
      Package: "4 LPA",
      Role: "Associate Software Engineer Trainee"
    },
    {
      SNo: 15,
      UniversitySerialNo: "20VV1A1207",
      StudentName: "Bandi Tulasi Asha",
      Discipline: "IT",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "Pennant Technologies Pvt.Ltd.",
      Package: "4 LPA",
      Role: "Associate Software Engineer Trainee"
    },
    {
      SNo: 16,
      UniversitySerialNo: "20VV1A1232",
      StudentName: "Machavarapu Mohan Durga Pradeep",
      Discipline: "IT",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "Pennant Technologies Pvt.Ltd.",
      Package: "4 LPA",
      Role: "Associate Software Engineer Trainee"
    },
    {
      SNo: 17,
      UniversitySerialNo: "20VV1A1213",
      StudentName: "Durla Mohanaa Vishnu Priya",
      Discipline: "IT",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "Pennant Technologies Pvt.Ltd.",
      Package: "4 LPA",
      Role: "Associate Software Engineer Trainee"
    },
    {
      SNo: 18,
      UniversitySerialNo: "20VV1A1214",
      StudentName: "Dwarampudi Hari Sankar Reddy",
      Discipline: "IT",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "Pennant Technologies Pvt.Ltd.",
      Package: "4 LPA",
      Role: "Associate Software Engineer Trainee"
    },
    
    {
      SNo: 19,
      UniversitySerialNo: "20VV1A1225",
      StudentName: "Karedla Aditya Lakshmi Narayana",
      Discipline: "IT",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "Pennant Technologies Pvt.Ltd.",
      Package: "4 LPA",
      Role: "Associate Software Engineer Trainee"
    },
      {
        SNo: 20,
        UniversitySerialNo: "20VV1A0103",
        StudentName: "Ambati Sireesha",
        Discipline: "Civil",
        OnOffCampus: "On Campus",
        NameOfTheEmployer: "L&T Constructions",
        Package: "6.6 LPA",
        Role: ""
      },
      {
        SNo: 21,
        UniversitySerialNo: "21VV5A0136",
        StudentName: "Meesala Lokesh Kumar",
        Discipline: "Civil",
        OnOffCampus: "On Campus",
        NameOfTheEmployer: "L&T Constructions",
        Package: "6.6 LPA",
        Role: ""
      },
      {
        SNo: 22,
        UniversitySerialNo: "20VV1A0111",
        StudentName: "Gattem Hanisha",
        Discipline: "Civil",
        OnOffCampus: "On Campus",
        NameOfTheEmployer: "L&T Constructions",
        Package: "6.6 LPA",
        Role: ""
      },
      {
        SNo: 23,
        UniversitySerialNo: "20VV1A0130",
        StudentName: "Vittanala Sai Chandana",
        Discipline: "Civil",
        OnOffCampus: "On Campus",
        NameOfTheEmployer: "L&T Constructions",
        Package: "6.6 LPA",
        Role: ""
      },
      {
        SNo: 24,
        UniversitySerialNo: "21VV5A0371",
        StudentName: "Mohmmed Noor Bhasha Mobeen",
        Discipline: "Mechanical",
        OnOffCampus: "On Campus",
        NameOfTheEmployer: "L&T Constructions",
        Package: "6.6 LPA",
        Role: ""
      },
      
{
    SNo: 25,
    UniversitySerialNo: "20VV1A0302",
    StudentName: "Annepu Manikanta",
    Discipline: "Mechanical",
    OnOffCampus: "On Campus",
    NameOfTheEmployer: "L&T Constructions",
    Package: "6.6 LPA",
    Role: ""
  },
  {
    SNo: 26,
    UniversitySerialNo: "20VV1A0308",
    StudentName: "Budi Deepika",
    Discipline: "Mechanical",
    OnOffCampus: "On Campus",
    NameOfTheEmployer: "L&T Constructions",
    Package: "6.6 LPA",
    Role: ""
  },
  {
    SNo: 27,
    UniversitySerialNo: "21VV5A0374",
    StudentName: "Rayala Hemanth Sai",
    Discipline: "Mechanical",
    OnOffCampus: "On Campus",
    NameOfTheEmployer: "L&T Constructions",
    Package: "6.6 LPA",
    Role: ""
  },
  {
    SNo: 28,
    UniversitySerialNo: "21VV5A0367",
    StudentName: "Guthapudi Chanakya",
    Discipline: "Mechanical",
    OnOffCampus: "On Campus",
    NameOfTheEmployer: "L&T Constructions",
    Package: "6.6 LPA",
    Role: ""
  },
  {
    SNo: 29,
    UniversitySerialNo: "20VV1A0317",
    StudentName: "Gedala Priyanka",
    Discipline: "Mechanical",
    OnOffCampus: "On Campus",
    NameOfTheEmployer: "L&T Constructions",
    Package: "6.6 LPA",
    Role: ""
  },
  {
    SNo: 30,
    UniversitySerialNo: "21VV5A0368",
    StudentName: "Kambidi Manichand",
    Discipline: "Mechanical",
    OnOffCampus: "On Campus",
    NameOfTheEmployer: "L&T Constructions",
    Package: "6.6 LPA",
    Role: ""
  },
  {
    SNo: 31,
    UniversitySerialNo: "20VV1A0319",
    StudentName: "Gelivi Sai Krishna",
    Discipline: "Mechanical",
    OnOffCampus: "On Campus",
    NameOfTheEmployer: "L&T Constructions",
    Package: "6.6 LPA",
    Role: ""
  },
  {
    SNo: 32,
    UniversitySerialNo: "20VV1A0335",
    StudentName: "Murala Yagna Pavan Kumar",
    Discipline: "Mechanical",
    OnOffCampus: "On Campus",
    NameOfTheEmployer: "L&T Constructions",
    Package: "6.6 LPA",
    Role: ""
  },
  {
    SNo: 33,
    UniversitySerialNo: "20VV1A0320",
    StudentName: "Gokavalasa Ushasree",
    Discipline: "Mechanical",
    OnOffCampus: "On Campus",
    NameOfTheEmployer: "L&T Constructions",
    Package: "6.6 LPA",
    Role: ""
  },
  {
    SNo: 34,
    UniversitySerialNo: "20VV1A0352",
    StudentName: "Rongali Swathi",
    Discipline: "Mechanical",
    OnOffCampus: "On Campus",
    NameOfTheEmployer: "L&T Constructions",
    Package: "6.6 LPA",
    Role: ""
  },
  {
    SNo: 35,
    UniversitySerialNo: "20VV1A0349",
    StudentName: "Pothula Swarna latha",
    Discipline: "Mechanical",
    OnOffCampus: "On Campus",
    NameOfTheEmployer: "L&T Constructions",
    Package: "6.6 LPA",
    Role: ""
  },
  {
    SNo: 36,
    UniversitySerialNo: "20VV1A0359",
    StudentName: "Thota Yaswanth Kumar",
    Discipline: "Mechanical",
    OnOffCampus: "On Campus",
    NameOfTheEmployer: "L&T Constructions",
    Package: "6.6 LPA",
    Role: ""
  },
  {
    SNo: 37,
    UniversitySerialNo: "20VV1A0328",
    StudentName: "Maddipatla Jaya Prakash",
    Discipline: "Mechanical",
    OnOffCampus: "On Campus",
    NameOfTheEmployer: "L&T Constructions",
    Package: "6.6 LPA",
    Role: ""
  },
  {
    SNo: 38,
    UniversitySerialNo: "20VV1A0345",
    StudentName: "Ponnada Karthik",
    Discipline: "Mechanical",
    OnOffCampus: "On Campus",
    NameOfTheEmployer: "L&T Constructions",
    Package: "6.6 LPA",
    Role: ""
  },
  {
    SNo: 39,
    UniversitySerialNo: "20VV1A0336",
    StudentName: "Nadikoti Sai Venkata Sravanthi",
    Discipline: "Mechanical",
    OnOffCampus: "On Campus",
    NameOfTheEmployer: "L&T Constructions",
    Package: "6.6 LPA",
    Role: ""
  },
  {
    SNo: 40,
    UniversitySerialNo: "20VV1A0305",
    StudentName: "Boddepalli Reshma",
    Discipline: "Mechanical",
    OnOffCampus: "On Campus",
    NameOfTheEmployer: "L&T Constructions",
    Package: "6.6 LPA",
    Role: ""
  },
  {
    SNo: 41,
    UniversitySerialNo: "20VV1A0364",
    StudentName: "Yandava Pragathi",
    Discipline: "Mechanical",
    OnOffCampus: "On Campus",
    NameOfTheEmployer: "L&T Constructions",
    Package: "6.6 LPA",
    Role: ""
  },
  
      {
        SNo: 42,
        UniversitySerialNo: "20VV1A0339",
        StudentName: "Patneedi Venkata Durga Prasad",
        Discipline: "Mechanical",
        OnOffCampus: "On Campus",
        NameOfTheEmployer: "L&T Constructions",
        Package: "6.6 LPA",
        Role: ""
      },
      {
        SNo: 43,
        UniversitySerialNo: "20VV1A0318",
        StudentName: "Geddam Jessie Deborah",
        Discipline: "Mechanical",
        OnOffCampus: "On Campus",
        NameOfTheEmployer: "L&T Constructions",
        Package: "6.6 LPA",
        Role: ""
      },
    {
      SNo: 44,
      UniversitySerialNo: "20VV1A0331",
      StudentName: "Modalavalasa Siva Kumar",
      Discipline: "Mechanical",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "L&T Constructions",
      Package: "6.6 LPA",
      Role: ""
    },
    {
      SNo: 45,
      UniversitySerialNo: "20VV1A0347",
      StudentName: "Potnuru Arjun",
      Discipline: "Mechanical",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "L&T Constructions",
      Package: "6.6 LPA",
      Role: ""
    },
    {
      SNo: 46,
      UniversitySerialNo: "20VV1A0350",
      StudentName: "Prasadu Mounika",
      Discipline: "Mechanical",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "CYIENT Ltd",
      Package: "4.2 LPA",
      Role: ""
    },

    {
      SNo: 47,
      UniversitySerialNo: "20VV1A0303",
      StudentName: "Basina Tarun",
      Discipline: "Mechanical",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "CYIENT Ltd",
      Package: "4.2 LPA",
      Role: ""
    },

    {
      SNo: 48,
      UniversitySerialNo: "20VV1A0326",
      StudentName: "Kshatri Rohit Singh",
      Discipline: "Mechanical",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "CYIENT Ltd",
      Package: "4.2 LPA",
      Role: ""
    },

    {
      SNo: 49,
      UniversitySerialNo: "20VV1A0334",
      StudentName: "Morla Venkata Naveen Kumar",
      Discipline: "Mechanical",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "CYIENT Ltd",
      Package: "4.2 LPA",
      Role: ""
    },

    {
      SNo: 50,
      UniversitySerialNo: "21VV5A0373",
      StudentName: "Peyyala Vikky",
      Discipline: "Mechanical",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "CYIENT Ltd",
      Package: "4.2 LPA",
      Role: ""
    },

    {
      SNo: 51,
      UniversitySerialNo: "20VV1A0327",
      StudentName: "Madda Raj Mouli",
      Discipline: "Mechanical",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "CYIENT Ltd",
      Package: "4.2 LPA",
      Role: ""
    },

    {
      SNo: 52,
      UniversitySerialNo: "20VV1A0363",
      StudentName: "Vittanala Surya Meghana",
      Discipline: "Mechanical",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "CYIENT Ltd",
      Package: "4.2 LPA",
      Role: ""
    },

    {
      SNo: 53,
      UniversitySerialNo: "20VV1A0331",
      StudentName: "Modalavalasa Siva Kumar",
      Discipline: "Mechanical",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "CYIENT Ltd",
      Package: "4.2 LPA",
      Role: ""
    },

    {
      SNo: 54,
      UniversitySerialNo: "20VV5A0370",
      StudentName: "Mandala Hemanth Kumar",
      Discipline: "Mechanical",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "CYIENT Ltd",
      Package: "4.2 LPA",
      Role: ""
    },
    
    {
      SNo: 55,
      UniversitySerialNo: "20VV1A0249",
      StudentName: "Reddi Vishnu Priya",
      Discipline: "EEE",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "MEDHA SERVO DRIVES",
      Package: "4 LPA",
      Role: ""
    },

    {
      SNo: 56,
      UniversitySerialNo: "20VV1A0501",
      StudentName: "Nutakki Manasa Lakshmi",
      Discipline: "CSE",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "EFFTRONICS SYSTEMS PVT.LTD",
      Package: "5 LPA",
      Role: ""
    },

    {
      SNo: 57,
      UniversitySerialNo: "20VV1A0518",
      StudentName: "Jonnakuti Ganesh Surya",
      Discipline: "CSE",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "EFFTRONICS SYSTEMS PVT.LTD",
      Package: "5 LPA",
      Role: ""
    },

    {
      SNo: 58,
      UniversitySerialNo: "20VV1A0519",
      StudentName: "Josyula Sai Tejaswini",
      Discipline: "CSE",
      OnOffCampus: "On Campus",
      NameOfTheEmployer: "EFFTRONICS SYSTEMS PVT.LTD",
      Package: "5 LPA",
      Role: ""
    },
    {
      SNo: 59,
      UniversitySerialNo: "20VV1A1221",
      StudentName: "Hanumanthu Vamshi Gangadhar",
      Discipline: "IT",
      OnOffCampus: "OFF Campus",
      NameOfTheEmployer: "Drishya AI Labs",
      Package: "7 LPA",
      Role: ""
    },

    
    {
      SNo: 60,
      UniversitySerialNo: "20VV1A1225",
      StudentName: "Karedla Aditya Lakshmi Narayana",
      Discipline: "IT",
      OnOffCampus: "OFF Campus",
      NameOfTheEmployer: "Drishya AI Labs",
      Package: "7 LPA",
      Role: ""
    },
    {
      SNo: 61,
      UniversitySerialNo: "20VV1A1233",
      StudentName: "Malla Naga Venkata Prasanth Naidu",
      Discipline: "IT",
      OnOffCampus: "OFF Campus",
      NameOfTheEmployer: "Drishya AI Labs",
      Package: "7 LPA",
      Role: ""
    },

    {
      SNo: 62,
      UniversitySerialNo: "20VV1A1236",
      StudentName: "Molugu Hari Kowshik",
      Discipline: "IT",
      OnOffCampus: "OFF Campus",
      NameOfTheEmployer: "Drishya AI Labs",
      Package: "7 LPA",
      Role: ""
    },


  ];
  
  export default studentsPlacedData;
  